/**
 * i18n messages for the client form (en/ar). Registered in
 * core/plugins/i18n.ts under its own `clients` namespace key. CSP-safe
 * compiler: only `{named}` placeholders.
 */
export const clientsMessages = {
  en: {
    clients: {
      email: "Email",
      logo: "Logo",
      logoUpload: "Upload logo",
      logoReplace: "Replace logo",
      logoRemove: "Remove logo",
      logoTooLarge: "The logo is too large. Choose an image under 5 MB.",
      logoNotImage: "This file is not an accepted image (PNG, JPEG or WebP).",
      logoFailed: "The logo could not be saved. Please try again.",
      logoSavedWithout: "Client saved without its logo",
    },
  },
  ar: {
    clients: {
      email: "البريد الإلكتروني",
      logo: "الشعار",
      logoUpload: "رفع الشعار",
      logoReplace: "استبدال الشعار",
      logoRemove: "إزالة الشعار",
      logoTooLarge: "حجم الشعار كبير جدًا. اختر صورة أقل من 5 ميغابايت.",
      logoNotImage: "هذا الملف ليس صورة مقبولة (PNG أو JPEG أو WebP).",
      logoFailed: "تعذر حفظ الشعار. يرجى المحاولة مرة أخرى.",
      logoSavedWithout: "تم حفظ العميل بدون شعاره",
    },
  },
};
